export default __webpack_public_path__ + "static/media/dont_underexpose.79835b11.png";